<body>
  <div id="settingbackground">
    <nav>
      <img class="logo" src="../../assets/images/logo1.png">
      <div class="menu">
        <span></span>
        <ul>
          <li><a (click)="routerService.GoToSetting(id)">設定</a></li>
          <li><a (click)="routerService.GoToControl(id)">控制</a></li>
          <li><a (click)="routerService.GoToOverview(id)">播放清單</a></li>
          <li><a (click)="routerService.GoToLottery(id)">抽獎</a></li>
        </ul>
      </div>
    </nav>
  </div>
  <div id="content" *ngIf="!isTwitchLogin">
    <button id="twitch_login" mat-raised-button color="primary" (click)="twitchLogin()">
      Twitch登入
    </button>
  </div>
  <div id="content" *ngIf="isTwitchLogin">
    <h6 id="title">抽獎</h6>
    <div class="input_file">
      <label for="csv_input">
        請上傳訂閱名單.csv:
      </label>
      <input id='csv_input' type="file" accept=".csv" (change)="handleFileInput($event.target.files)">
    </div>
    <div class="contoller">
      <mat-checkbox [(ngModel)]="isTenureBouns">是否按照訂閱月數增加權重</mat-checkbox>
      <mat-form-field *ngIf="isTenureBouns">
        <mat-label>月數</mat-label>
        <input type="number" matInput placeholder="100" [(ngModel)]="tenureBounsMonths">
        <mat-hint>每幾個月增加一次抽獎機率</mat-hint>
      </mat-form-field>
      <mat-checkbox [(ngModel)]="isRepeat">同一個人是否可以抽到不同獎</mat-checkbox>
      <mat-checkbox [(ngModel)]="isForGifter">是否抽獎給贈禮者</mat-checkbox>
    </div>
    <div class="awards" *ngFor="let award of awards; let i=index">
        <mat-form-field class="award_name" appearance="legacy">
          <mat-label>名稱</mat-label>
          <input type="text" matInput placeholder="Godjj滑鼠墊" [(ngModel)]="award.name">
          <mat-hint>獎項名稱</mat-hint>
        </mat-form-field>
        <mat-form-field class="award_number_of_people">
          <mat-label>數量</mat-label>
          <input type="number" matInput placeholder="100" [(ngModel)]="award.numberOfPeople">
          <mat-hint>抽取人數</mat-hint>
        </mat-form-field>
        <ng-container *ngIf="i==awards.length-1; else notLast">
          <fa-icon class="add_award" [icon]="faPlusSquare" (click)="addAward()"></fa-icon>
        </ng-container>
        <ng-template #notLast>
          <fa-icon class="remove_award" [icon]="faMinusSquare" (click)="removeAward(i)"></fa-icon>
        </ng-template>
    </div>
    <div>
      <button id="make_pool" mat-raised-button color="primary" (click)="makeLotteryPool()">
        製作抽獎池
      </button>
      <button id="get_winner" mat-raised-button color="primary" (click)="getWinner()" *ngIf="lotteryPool.length > 0">
        抽獎
      </button>
    </div>
  </div>
  <div id="processing_overlay" *ngIf="isProcessing">
    <fa-icon class="processing" [icon]="faSpinner" [spin]="true"></fa-icon>
  </div>
  <div id='content' *ngIf="isWinnerGet">
    <div class='unboxing_button'>
      <mat-button-toggle-group [(ngModel)]="chooseAwardName" (click)="chooseToggleButton(chooseAwardName)">
        <mat-button-toggle *ngFor="let award of awards" value="{{award.name}}">{{award.name}}</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="winner" *ngIf="chooseAward">
      <p *ngFor="let winner of chooseAward.winner"> {{winner}} </p>
    </div>
  </div>
</body>
